import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import {useDownloadPanelData} from '@Components/download-panel/download-panel.context';
import {MAX_NUMBER_OF_DOWNLOADABLE_PAGES_FOR_PAYG_USERS} from '@Libraries/poster-download-library';
import {isUserPAYG} from '@Libraries/user.library';
import {NEW_SUBSCRIPTION_START_SOURCE_COOKIE, NewSubscriptionStartSource} from '@Libraries/ga-events';
import {COOKIE_EXPIRY_30_MINUTES, setCookie} from '@Utils/cookie.util';
import {openPremiumPricingModal} from '@Modals/premium-pricing-modal/premium-pricing-modal.library';
import styles from './download-payg-pages-upselling.module.scss';

export function DownloadPaygPagesUpselling(): ReactElement | null {
  const {posterObject} = useDownloadPanelData();
  const totalNumberOfPages = posterObject.pages.pageOrder.length;
  const isPAYGUser = isUserPAYG();
  const isPaygDownloadPagesLimitEnabled = isPAYGUser && totalNumberOfPages > MAX_NUMBER_OF_DOWNLOADABLE_PAGES_FOR_PAYG_USERS;

  const onClickUpsellingHandler = (): void => {
    setCookie(NEW_SUBSCRIPTION_START_SOURCE_COOKIE, NewSubscriptionStartSource.PAYG_MULTIPAGE_LIMIT_DIALOG, COOKIE_EXPIRY_30_MINUTES);
    openPremiumPricingModal(false);
  };

  if (!isPaygDownloadPagesLimitEnabled) {
    return null;
  }

  return (
    <div className={`spacing-p-t-2 spacing-p-b-2 spacing-p-l-3 spacing-p-r-3 radius-4 ${styles.upsellingBg}`}>
      <Text
        onClick={(e): void => {
          const target = e.target as HTMLElement;
          if (target?.id === 'upgrade') {
            onClickUpsellingHandler();
          }
        }}
        dangerouslySetInnerHTML
        className="content-premium"
        val={window.i18next.t('pmwjs_payg_download_page_limit_message', {
          limit: MAX_NUMBER_OF_DOWNLOADABLE_PAGES_FOR_PAYG_USERS,
        })}
        size={TextSize.XSMALL}
      />
    </div>
  );
}
